import './PeriscopeTypeLabel.scss';
import React from 'react';
import { Tooltip } from 'antd';
import { displayFieldType, getSonarObjectTypeLabel } from '@sonar-software/sonar-ts-lib';
export const PeriscopeTypeLabel = ({ headerLabel, sonarObjectType, subType }) => {
    const displayText = headerLabel !== null && headerLabel !== void 0 ? headerLabel : getSonarObjectTypeLabel(sonarObjectType);
    const subtypeText = displayFieldType(subType !== null && subType !== void 0 ? subType : '');
    return (React.createElement("div", { className: 'periscope-type-subtype-labels' },
        React.createElement("div", { className: 'periscope-type-label' }, displayText),
        Boolean(subType) &&
            React.createElement(Tooltip, { title: subtypeText },
                React.createElement("div", { className: 'periscope-subtype-label' }, subtypeText))));
};
